export const selectInput = (event: Event) => {
    const target = event.target as HTMLInputElement | null
    if (target) {
        target.select()
    }
}